<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item filter_item_xxl">
            <EnumFilter :label-text="$t('common.type')"
                        columnName="receivableType"
                        :enum-def="enumDef.receivableType"
                        ref="filter_receivableType"
            ></EnumFilter>
            <TextFilter :label-text="$t('common.debtor')"
                        columnName="debtorName"
                        ref="filter_debtorName"
            ></TextFilter>
            <TextFilter :label-text="$t('common.seller')"
                        columnName="sellerName"
                        ref="filter_sellerName"
            ></TextFilter>
            <TextFilter :label-text="$t('common.invoiceNumber')"
                        columnName="invoiceNumber"
                        ref="filter_invoiceNumber"
            ></TextFilter>
            <DateFilter :label-text="$t('common.dueDate')"
                        column-name="dueDate"
                        ref="filter_dueDate"
            ></DateFilter>
            <FromToFilter :label-text="$t('common.outstanding.amount')"
                          columnName="outstandingAmount"
                          ref="filter_outstandingAmount"
            ></FromToFilter>
            <FromToFilter :label-text="$t('common.outstanding.percent')"
                          columnName="outstandingPercent"
                          ref="filter_outstandingPercent"
            ></FromToFilter>
			<TextFilter :label-text="$t('common.contractNumber')"
						column-name="installmentContractNumber"
						ref="filter_installmentContractNumber"
			></TextFilter>
        </div>
    </TableFilter>
</template>

<script>
import DateFilter from "@/components/newFilter/DateFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import EnumFilter from "@/components/newFilter/EnumFilter";
import {enumDef} from "@/common/enumDefs";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: {
        TableFilter,
        EnumFilter,
        FromToFilter,
        DateFilter,
        TextFilter
    },
    data() {
        return {
            enumDef: enumDef
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>
